import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeProvider';
import DynamicLocaleProvider from './context/DynamicLocaleProvider';
import { UserProvider } from './context/UserContext';
import { ToastProvider } from './context/ToastProvider';

// Import Firebase config to ensure it's initialized
import './lib/firebase';

// Initialize brand switcher
import './utils/brandSwitcher';

// Import AuthView component
import AuthView from './components/AuthView';

// Lazy load HubSpotChat - it's not critical for initial render
const HubSpotChat = lazy(() => import('./components/HubSpotChat'));

function App() {
  return (
    <UserProvider>
      <ThemeProvider>
        <DynamicLocaleProvider>
          <ToastProvider>
            <Router>
              <AuthView />
              {/* HubSpot Chat Widget - Lazy loaded */}
              <Suspense fallback={null}>
                <HubSpotChat portalId="144339005" />
              </Suspense>
            </Router>
          </ToastProvider>
        </DynamicLocaleProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
